import { createCrudHooks } from "../common/queries";

export const subjectApi = createCrudHooks({
	baseKey: "subjects",
	basePath: "/subjects",
});
